const userDashboardDictES = {
  dashboard: "Panel de Controle",
  userDashboard: "Panel de Controle del Usuario",
  wallet: "Billetera",
  transfer: "Transferir",
  transferRequests: "Solicitaciones de Transferencia",
  productServices: "Productos y servicios",
  maxBalanceReached: "Has alcanzado tu saldo máximo.",
  new: "Nuevo",
  dropshipping: "Dropshipping",
  list: "Lista",
  sales: "Ventas",
  purchases: "Compras",
  network: "Círculo Económico",
  directs: "Directos",
  all: "Todos",
  coupons: "Cupones",
  attributes: "Atributos",
  withdraw: "Retiro",
  yourStore: "Tu Tienda",
  favorites: "Favoritos",
  isService: "¿Esta subcategoría es un servicio?",
  importProducts: "Importar Productos",
  pageNotFound: "Página no encontrada",
  popupHeader1: "Tienes",
  popupHeader2: "día(s) para caducar tu suscripción",
  subscriptionExpirationDate: "Fecha de vencimiento de la suscripción",
  wantToRenewSubscription: "¿Quieres renovar tu suscripción?",
  subscription: "Suscripción",
  renewSubscription: "Renovar Suscripción",
  payWithPaypal: "Pagar con Paypal",
  walletBalancerRenew: "Saldo en la billetera",
  paymentMethods: "Métodos de pago",
  errorRenewingSubscription: "Hubo un error al renovar su suscripción, inténtelo de nuevo",
  youWantRenewWalletBalance: "¿Quieres renovar con el saldo de la billetera?",
  subscriptionRenewed: "¡Suscripción renovada con éxito!",
  yourSubcriptionExpired: "Su suscripción ha expirado",
  wantToRenewyourSubscription: "¿Quieres renovarlo?",
  unfavorite: "Desfavorito",
  waitLabel:
    "Espere a que se genere su etiqueta. Simplemente presione el botón de abajo cuando su pedido sea recogido por el transportista.",
  freeRenewalsRemaining: "Renovaciones gratuitas restantes",
  BOZZA: "Esperando aprobación",
  INSPEDIZIONE: "En tránsito",
  RITIRORICHIESTO: "Retiro solicitado",
  CONSEGNATA: "Entregado",
  errorDownloadLabel: "Hubo un error al crear la etiqueta",
  nextAction: "Siguiente",
  closeAction: "Cerrar",
  backAction: "Atrás",
  welcomeToExtraconomy: "Bienvenido a Extraconomy",
  dashboardWelcomeMessage: "Bienvenido a ",
  ifYouWantToSellOnExtraconomy:
    "Si deseas vender en extraconomy, sigue los pasos para aprender cómo crear tu tienda y tus productos",
  registerYourAddress: "Registre su dirección",
  initiallyYouNeedToRegisterYourAddress:
    "Inicialmente necesitas registrar tu dirección para que podamos usarla para las entregas",
  fillInYourContactPhoneNumber: "Complete su número de teléfono de contacto",
  fillInYourContactNumber:
    "Complete su número de teléfono de contacto para que podamos contactarlo si es necesario",
  fillInTheDetailsAboutTheShippingService: "Complete los detalles sobre el servicio de envío",
  saveTheModifiedInformation: "Guardar la información modificada",
  afterFillingInAllTheInformation:
    "Después de completar toda la información, haga clic en guardar para que se guarde la información.",
  onThisPageYouWillConfigure: "En esta página configurará los detalles de su tienda",
  finallyOnThisPageYouWillRegisterYourProducts:
    "Finalmente, en esta página registrará sus productos",
  publicKey: "clave pública",
  privateKey: "clave privada",
  accessWallet: "Acceder a la billetera",
  disconnectWallet: "Desconectar Carteira",
  notifications: "Notificaciones",
  noNotifications: "No hay notificaciones",
  StoresMap: "Mapa de Tiendas",
  map: "Mapa",
  physicalStore: "Tiendas Físicas",
  payments: "Pagos",
  payWithQrCode: "Pago con código QR",
  payWithQrCodeDescription: "Apunta tu cámara al código QR de pago.",
  createChargeWithQrCode: "Creación de cobranza",
  createChargeWithQrCodeDescription: "Crea una cobranza por QR Code",
  paymentTransaction: "¿Quieres realizar el pago de esta transacción?",
  pay: "Pagar",
  transactionValue2: "Valor de la transacción",
  banners: "Banners",
  amountToBeReceived: "Valor a recibir",
  discountPercentual: "Descuento porcentual",
  discountAbsolut: "Descuento absoluto",
  none: "Ninguno",
  percentual: "Porcentual",
  minimalOrderValueToActivateSetting: "Valor mínimo de pedido para activar la configuración",
  successSaveFreightRule: "Regla de flete guardada con éxito",
  feightRules: "Reglas de flete",
  setShippingRulesForYourStore: "Establezca reglas de envío para su tienda.",
  newFringeBenefit: "Nuevo Beneficio Adicional",
  newProduct: "Nuevo Producto",
  listProducts: "Lista de Productos",
  listFringeBenefits: "Lista de Beneficios Adicionales",
  video: "Video",
  dragVideoFile: "Arrastra el archivo de video aquí",
  videoUploadedSuccessfully: "Video cargado con éxito",
  videoNotSupported: "Su navegador no admite la reproducción de video",
  uploadVideoMaxSize20MB: "Sube un video de hasta 20 MB para tu tienda",
  videoSizeExceeds20MB: "El tamaño del video supera los 20 MB",
  balanceAvailableForWithdrawal: "Saldo disponible para retiro:",
  centralFinanceira: "Central Financiera",
  financialHubSubtitle: "Seguimiento y gestión de las operaciones de su billetera Extraconomy.",
  patrimonyConsolidated: "Patrimonio consolidado",
  last30Days: "en los últimos 30 días",
  walletEuro: "BILLETERA",
  withdrawable: "RETIRABLE",
  availableForWithdrawal: "Disponible para retiro",
  withdrawAction: "Retirar",
  statement: "Extracto",
  useInStore: "Usar en la tienda",
  extracredit: "Extracredit",
  consumption: "CONSUMO",
  purchasingPower: "poder adquisitivo",
  quickOperations: "Operaciones Rápidas",
  transferECR: "Transferir ECR",
  financial: "Financiero",
  overview: "Resumen",
  transactions: "Transacciones",
  lifetimeWalletId: "ID",
  lifetimeWalletEntry: "Entrada",
  lifetimeWalletOutcome: "Salida",
  bankAccounts: "Cuentas bancarias",
  balanceSummary: "Resumen del saldo",
  totalAvailable: "Total disponible",
  credit: "Crédito",
  debit: "Débito",
  originOfFunds: "Origen de los recursos financieros",
  transactionsCarriedOut: "Transacciones realizadas",
  withdrawals: "Retiros",
  requestWithdrawal: "Solicitar retiro",
  dailyIncome: "Ingreso diario",
  noBankAccountWarning:
    "Ninguna cuenta bancaria registrada. Para solicitar retiros, registre una cuenta.",
  bankAccountSettingsLink: "Configuración de cuentas bancarias",
  requestWithdrawalButton: "Solicitar retiro",
  history: "Historial",
  availableBalance: "Saldo disponible",
  howToUseCredits: "Cómo usar sus créditos",
  creditMovement: "Movimiento de créditos",
  comingSoon: "Próximamente",
  invest: "Invertir",
  swap: "Swap",
  bankAccountFormTitle: "Registro de cuenta bancaria",
  bankAccountFormTitleEdit: "Editar cuenta bancaria",
  bankAccountFormSubtitle: "Ingrese los datos de su cuenta.",
  identification: "Identificación",
  mainAccount: "Cuenta principal",
  mainAccountHelp: "Marque para definir como cuenta principal.",
  bankDetails: "Datos bancarios",
  accountType: "Tipo de cuenta",
  email: "Correo electrónico",
  bankAccountRegister: "Registrar",
  registeringAccount: "Registrando su cuenta. Espere.",
  invalidIban: "IBAN inválido. Verifique el número informado.",
  accountRegisteredSuccess: "Cuenta registrada con éxito.",
  accountUpdatedSuccess: "Cuenta actualizada con éxito.",
  accountDeletedSuccess: "Cuenta eliminada con éxito.",
  addAccount: "Registrar cuenta",
  configure: "Configurar",
  myAccounts: "Mis cuentas",
  noAccountsMessage:
    "Aún no tiene cuentas bancarias registradas. Registre una nueva cuenta para realizar transferencias.",
  transferTo: "Transferir a",
  selectAccount: "Seleccione una cuenta",
  processingWithdrawal: "Procesando retiro...",
  cancel: "Cancelar",
  save: "Guardar",
  principal: "Principal",
  delete: "Eliminar",
  confirmDeleteAccount: "¿Está seguro de que desea eliminar esta cuenta?",
  attention: "Atención",
  yes: "Sí",
  no: "No",
  confirmWithdrawal: "Confirmar retiro",
  searchByTransaction: "Buscar por transacción",
  filter: "Filtrar",
  transaction: "Transacción",
  operationType: "Tipo de operación",
  registrationDate: "Fecha de registro",
  noOperationsRecords: "Aún no hay registros de operaciones.",
  saleInStore: "Venta de producto en la tienda",
  purchaseInStore: "Compra de producto en la tienda",
  register: "Registrar",
  paymentMethodExtracredit: "Extracredit",
  paymentMethodWallet: "Saldo de la billetera",
  paymentMethodPayPal: "PayPal",
  paymentMethodBankTransfer: "Transferencia bancaria",
  paymentMethodMultiple: "Múltiples",
  pendingReceipts: "Recepción pendiente",
  pendingReceiptsSent: "envió",
  pendingReceiptsHint: "Estos valores solo se acreditarán después de la aceptación.",
  approve: "Aprobar",
  recipientSelection: "Selección del destinatario",
  recipientSelectionHint: "Seleccione quién recibirá su transferencia.",
  chooseRecipient: "Elija el destinatario",
  searchRecipient: "Buscar destinatario...",
  userNotFound: "Este usuario no fue encontrado. Verifique los datos e intente de nuevo.",
  recipientDetails: "Detalles del destinatario",
  changeRecipient: "Cambiar destinatario",
  values: "Valores",
  valuesHint: "Ingrese cuánto desea transferir a {name}.",
  available: "Disponible",
  enterAmount: "Ingrese el valor",
  platformFee: "Tarifa de la plataforma",
  transferSummary: "Resumen de la transferencia",
  transferSummaryHint: "Revise y confirme antes de finalizar.",
  sendTo: "Enviar a",
  recipient: "Destinatario",
  transferCompleted: "Transferencia realizada",
  goToStatement: "Ir al extracto",
  powerOfUse: "Poder de uso",
  powerOfUseDescription: "Pague hasta {percent}% de sus compras con su saldo de Extracredit.",
  powerOfUseLabel: "Puedes usar hasta {percent}% de tu saldo ECR",
  powerOfUseManagerRule: "Por cada referido pagado (no voucher) desbloquea 2%.",
  powerOfUseOtherRule: "Por cada referido pagado desbloquea 1%.",
  unlocked: "desbloqueado",
  goal: "Meta",
  unlockMore: "Desbloquear +",
  powerOfUseManagerUnlock: "Invite nuevos Partners (pagados, no voucher) para aumentar su límite.",
  powerOfUseOtherUnlock: "Invite nuevos Partners pagados para aumentar su límite.",
  opportunitiesToUse: "Oportunidades con Extracréditos",
  accessStore: "Acceder a la tienda",
  completeStatement: "Extracto completo",
  useCreditPercent: "Use {percent}% Crédito",
  credits: "Créditos",
  totalValue: "Valor total",
  transferExtracredit: "Transferir Extracredit",
  transferExtracreditSubtitle:
    "Transfiera Extracréditos a otros usuarios en el ecosistema Extraconomy.",
  transferConfirmDisclaimerBefore: "Al hacer clic en ",
  sendCredits: "Enviar créditos",
  transferConfirmDisclaimerMiddle: ", concedo permiso a ",
  companyExtraconomy: "Extraconomy",
  transferConfirmDisclaimerAfter: " para proceder con la transacción detallada.",
  securityValidationTitle: "Validación de seguridad",
  securityValidationEmailSent:
    "Para tu seguridad, enviamos un código de {length} caracteres a {email}",
  securityValidationConfirmTransfer:
    "Ingresa el código para confirmar la transferencia de {amount} a {recipient}",
  securityValidationConfirmWithdrawal:
    "Ingresa el código para confirmar el retiro de {amount} a {recipient}",
  securityValidationCodeExpires: "el código expira en {time}",
  securityValidationResend: "Reenviar código",
  securityValidationResendIn: "Reenviar código (en 5min)",
  securityValidationValidate: "Validar código",
  rejectNotAvailable: "Rechazar no está disponible.",
  search: "Buscar",
  toAgreeAndReceiveInsertCode: "Para aceptar y recibir, ingrese el código enviado a su email:",
  confirmYourAction: "Confirme su acción",
  seeDetails: "Ver detalles",
  whiteLabel: "White Label",
  whiteLabelSettingsTitle: "Configuración de apariencia",
  whiteLabelSettingsSubtitle: "Personaliza la configuración de apariencia de tu dashboard.",
  whiteLabelSaveChanges: "Guardar cambios",
  whiteLabelAssets: "Recursos",
  whiteLabelLogo: "Logo",
  whiteLabelFavicon: "Favicon",
  whiteLabelChooseFile: "Elegir archivo",
  whiteLabelClickToUpload: "Haz clic para cargar",
  whiteLabelOrDragDrop: "o arrastra y suelta",
  whiteLabelFileFormatsLogo: "SVG, PNG, JPG o GIF (máx. 400×400px)",
  whiteLabelFileFormatsFavicon: "SVG, PNG, JPG o GIF (máx. 64×64px)",
  whiteLabelBrandColors: "Colores de marca",
  whiteLabelPrimaryColor: "Color principal",
  whiteLabelSecondaryColor: "Color secundario",
  whiteLabelBackgroundColor: "Fondo de la plataforma",
  whiteLabelTextColor: "Color del texto",
  whiteLabelTypography: "Tipografía",
  whiteLabelFont: "Fuente",
  whiteLabelSelectFont: "Seleccionar fuente",
  whiteLabelImageUploaded: "Imagen subida correctamente",
  whiteLabelThemeCreated: "Tema creado correctamente",
  whiteLabelThemeUpdated: "Tema actualizado correctamente",
  whiteLabelChangesReset: "Cambios restaurados a los valores predeterminados",
  whiteLabelDefaultSettings: "Configuración predeterminada",
  whiteLabelCustomNetworkDefault: "Red personalizada",
  whiteLabelPrimaryColorHelp:
    "Representa la identidad de tu marca. Se utilizará para botones de acción, enlaces activos y elementos de mayor importancia.",
  whiteLabelSecondaryColorHelp:
    "Un color secundario para crear contraste. Aparecerá en insignias, iconos de fondo y detalles visuales secundarios.",
  whiteLabelBackgroundColorHelp:
    "El color predominante detrás del contenido. Recomendamos tonos claros (como blanco o gris claro) para facilitar la lectura.",
  whiteLabelTextColorHelp:
    "Define el color de títulos y párrafos. Elige un tono oscuro que contraste bien con el fondo de la plataforma.",
  whiteLabelFontHelp:
    "La familia tipográfica que dará voz a tu plataforma. Elige una fuente legible y alineada con tu imagen de marca.",
  whiteLabelLogoPreview: "Vista previa del logo",
  whiteLabelFaviconPreview: "Vista previa del favicon",
  myCards: "Mis Tarjetas",
  myCardsSubtitle: "Visualiza y gestiona tus tarjetas virtuales.",
  myCardsEmpty: "No hay tarjetas disponibles.",
  myCardsClickToFlip: "Haz clic en la tarjeta para voltearla",
  myCardActive: "Activa",
  myCardInactive: "Inactiva",
  orderSingular: "pedido",
  orderPlural: "pedidos",
  awaitingProcessing: "Esperando procesamiento",
  noPending: "Ninguna pendiente",
  managerDashboardErrorLoad: "Error al cargar los datos del panel",
  managerStoreStatusPending: "Pendiente",
  managerNetworkLevelSenior: "Senior",
  managerWalletChangeVsPrevious: "+2% vs mes anterior",
  managerBalanceSales: "de ventas",
  managerTrackStoreHere: "Sigue tu tienda aquí.",
  managerBilling: "FACTURACIÓN",
  managerInProcessing: "en proceso",
  managerLiveStore: "TIENDA EN VIVO",
  managerNetworkEarnings: "GANANCIAS DE RED",
  managerNetworkLevelLabel: "Nivel de red",
  managerTotalEarnings: "Ganancias totales",
  managerB2bPurchasingPower: "Poder de compra B2B",
  managerBonusAds: "Bonus ADS",
  managerAdsForExternalAds: "ads para anuncios externos",
  managerFooterCompanyName: "EXTRACONOMY GLOBAL srl",
  managerFooterAddress: "Via Nomentana, 1018 - 00137 Roma (IT)",
  managerFooterTaxInfo: "CIF y NIF 16948681008",
  managerFooterRea: "REA 1686351",
  economicCircle: "Círculo Económico",
  economicCircleSubtitle: "Sigue tu círculo económico y expansión.",
  invite: "Invitar",
  inviteSubtitle: "Invita miembros y expande tu red de influencia.",
  currentStatus: "Estado actual",
  members: "Miembros",
  networkPower: "Poder de red",
  activeInfluence: "Influencia activa",
  networkEarnings: "Ganancias de red",
  thisMonth: "este mes",
  totalAccumulatedLifetime: "Total acumulado (Lifetime)",
  directCommission: "Comisión directa",
  networkCommission: "Comisión de red",
  networkHighlightsTop5: "Destacados de la red (Top 5)",
  recentMembers: "Miembros recientes",
  viewAll: "Ver todo",
  transactionHistory: "Historial de transacciones",
  noRecentMembers: "Ningún miembro reciente.",
  origin: "Origen",
  type: "Tipo",
  date: "Fecha",
  value: "Valor",
  paid: "Pagado",
  goalForGold: "Meta para GOLD",
  copied: "Copiado",
  copiedToClipboard: "Copiado al portapapeles",
  qrcodereferralLinks: "Código QR de enlaces de referido",
  referralLinksExplanation: "Inicia sesión para generar enlaces de referido.",
  share: "Compartir",
  directMembers: "Miembros directos",
  indirectMembers: "Miembros indirectos",
  totalReceived: "Total recibido",
  withdrawalsMade: "Retiros realizados",
  membersAndTransactions: "Miembros y transacciones",
  membersAndTransactionsSubtitle: "Miembros y transacciones de tu círculo.",
  searchByMember: "Buscar por miembro",
  indirects: "Indirectos",
  noMembers: "Ningún miembro.",
  name: "Nombre",
  actions: "Acciones",
  completed: "Completado",
  pending: "Pendiente",
  canceled: "Cancelado",
  active: "Activo",
  inactive: "Inactivo",
  activeDigitalAssets: "Activos digitales",
  privacyPolicy: "Política de privacidad",
  managerMobileNavOpenMenu: "Abrir menú",
  partnerB2bTitle: "Partner B2B",
  partnerB2bSubtitle: "Encuentra y conecta con socios estratégicos en tu región.",
  partnerB2bSearchPlaceholder: "Códigos ATECO o áreas de actividad...",
  partnerB2bRadiusLabel: "Radio",
  partnerB2bRadiusKm: "km",
  partnerB2bSearch: "Buscar",
  partnerB2bAddressWarningText:
    "Es necesario configurar tu posición (código postal y dirección) para usar la búsqueda geolocalizada.",
  partnerB2bConfigurePosition: "Configurar posición",
  partnerB2bEmptyState:
    "No se encontraron resultados con los criterios actuales. Prueba a ampliar el radio de búsqueda o quitar algunos filtros.",
  partnerB2bSubnetOnly: "Esta página está disponible solo para miembros de una subnet.",
  partnerB2bContact: "Contacto",
  partnerB2bActivities: "Actividades / ATECO",
  partnerB2bContactPartner: "Contactar al partner",
  partnerB2bGetDirections: "Obtener indicaciones",
  partnerB2bDistanceFromYou: "A {km} km de ti",
  partnerB2bClosestPartners: "Socios más cercanos",
  partnerB2bShowingResultsInRadius: "Mostrando {count} {countLabel} en un radio de {radius} km",
  partnerB2bResult: "resultado",
  partnerB2bResults: "resultados",
  partnerB2bWaitingForSearch: "Esperando una búsqueda para listar socios.",
  partnerB2bNoPartnersFound: "No se encontraron socios con los filtros actuales.",
  partnerB2bFromYou: "de ti",
  partnerServicesTitle: "Servicios para socios",
  partnerServicesTabBusiness: "Servicios para empresas",
  partnerServicesTabIndividuals: "Servicios para particulares",
  partnerServicesActivateService: "Activar servicio",
  partnerServicesAwaitingFeedback: "Esperando respuesta",
  partnerServicesServiceActivated: "Servicio activado con éxito",
  partnerServicesServiceActivationFailed: "Error al activar el servicio",
  partnerServicesMenuLabel: "Servicios para socios",
  backToFedernet: "Volver a la Asociación",
  performanceChartLabel: "Rendimiento Comercial",
  performanceChartTitle: "Rendimiento comercial",
  performanceChartErrorLoadingData: "Error al cargar los datos",
  performanceChartLoading: "Cargando...",
  accessCommercialDashboard: "Acceder al panel comercial",
  recentOperations: "Últimas operaciones",
  recentOperationsJustNow: "Ahora",
  recentOperationsMoreItems: "(+{count})",
  recentOperationsCustomerEmptyState: "Aún no has realizado operaciones de compra.",
  recentOperationsExploreStore: "Conocer la tienda Extraconomy",
  customerHomeExtracreditBalanceTitle: "Saldo Extracredit (ECR)",
  customerHomeExtracreditEquivalent: "Equivalente a ~ {value} en el circuito",
  customerHomePendingTransactionsTitle: "Transacciones pendientes",
  customerHomePendingTransactionsSubtitle: "Visualiza tus pedidos",
  customerHomeQuickActionsTitle: "Funciones rápidas",
  customerHomeExploreStores: "Explorar tiendas",
  customerHomeFutureTitle: "Próximamente: nuevas funcionalidades para Customers.",
  customerHomeFutureSubtitle:
    "Estamos preparando nuevos recursos para ampliar las posibilidades de compra y servicios en tu panel.",
  customerHomeFutureImageAlt: "Sección informativa customer",
  myPurchases: "Mis compras",
  myPurchasesSubtitle: "Sigue tus compras y el estado de cada pedido.",
  totalPurchases: "Total de compras",
  lastPurchaseDate: "Última compra",
  noPurchases: "Ninguna compra aún",
  searchByIdOrSeller: "Buscar por ID o vendedor",
  partnerStoresMenuLabel: "Tiendas asociadas",
  upgradePageNotAvailableTitle: "Actualización no disponible",
  upgradePageNotAvailableDescription:
    "Este perfil no tiene opciones de actualización de plan disponibles en este momento.",
  upgradePageHeadlineCustomer: "Desbloquea tu potencial de ganancias",
  upgradePageHeadlinePartner: "Escala tu negocio en el e-commerce",
  upgradePageHeadlineSeller: "Domina el territorio con geolocalización",
  upgradePageHeadlineStore: "Inicia tu crecimiento en e-commerce",
  upgradePageSubheadlineCustomer:
    "Conviértete en Partner o Manager para acceder al plan de carrera y generar ingresos concretos en nuestro ecosistema.",
  upgradePageSubheadlinePartner:
    "Activa el plan StartSeller y lleva tu tienda física online, superando cualquier frontera geográfica.",
  upgradePageSubheadlineSeller:
    "Migra al perfil Manager para recibir automáticamente clientes de tu zona a través de nuestra app.",
  upgradePageSubheadlineStore:
    "Activa el plan Start Seller para desbloquear ventas online y publicación de productos en el marketplace.",
  upgradePaymentTitle: "Completar actualización",
  upgradeMostPopular: "más elegido",
  upgradePlanNamePartner: "PARTNER",
  upgradePlanNameSeller: "SELLER",
  upgradePlanNameManager: "MANAGER",
  upgradePlanNameStartSeller: "START SELLER",
  upgradePlanDescriptionPartner: "Para quienes empiezan a vender online.",
  upgradePlanDescriptionSeller: "Para quienes quieren aumentar sus ventas.",
  upgradePlanDescriptionManager: "Para quienes quieren ampliar su negocio.",
  upgradePlanDescriptionStartSeller: "Para quienes quieren aumentar sus ventas.",
  upgradeFeatureStorefront: "Vitrina online",
  upgradeFeatureEconomicCircle: "Círculo económico",
  upgradeFeatureNoMonthlyFee: "Sin pagos mensuales",
  upgradeFeaturePersonalEcommerce: "E-commerce personal",
  upgradeFeatureDropshipping: "Incluye dropshipping",
  upgradeFeatureOnlineStore: "Tienda online",
  upgradeFeatureGeolocationActive: "Geolocalización activa",
  upgradeFeatureAllIncluded: "Todo incluido",
  upgradeStartSellerRenewal: "Renovación anual: EUR 35,00",
  storeActivateStartSellerWarning:
    "Para publicar productos, activa el plan Start Seller en el upgrade de la cuenta.",
  storeActivateStartSellerCta: "Activar Ventas Online Start Seller",
  productLimitReached:
    "Has alcanzado el límite de {limit} anuncios de tu plan. Actualiza tu plan para agregar nuevos anuncios.",
  storeProductsLimitWarning:
    "Has alcanzado el límite de {limit} anuncios de tu plan. Haz upgrade para seguir agregando productos y servicios.",
  paymentsPysicalStore: "Pagos de la tienda física",
  payPhysicalStore: "Pagar tienda física",
  physicalStoreProofSubmitted: "Comprobante enviado, en espera de validación.",
  securityCodeLabel: "Código de seguridad (enviado a tu correo):",
  securityCodeSend: "Enviar código",
  securityCodeResend: "Reenviar código",
  securityCodeHint: "Haz clic en \"Enviar código\" e ingresa el código que llegue a tu correo. Cada nuevo envío invalida el código anterior.",
  securityCodeSent: "¡Código enviado! Revisa tu correo.",
  securityCodeCantBeEmpty: "Ingresa el código de seguridad enviado a tu correo.",
  securityCodeIsWrong: "Código de seguridad inválido o expirado.",
};

export default userDashboardDictES;
